const processStatusChoice = [
    { id: 1, name: 'Enviado' },
    { id: 2, name: 'Erro no envio' },
    { id: 3, name: 'Em processamento' },
]

export const PROCESS_STATUS_SUCCESS_SEND = 1;

export default processStatusChoice;